import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { OrderFacade } from '@spartacus/order/root'

@Injectable({
  providedIn: 'root'
})
export abstract class MbOrderFacade extends OrderFacade {
  abstract get isPlaceOrderTriggered(): Observable<boolean>
  abstract stopPlaceOrderTrigger(): void
  abstract redirectToPaymentPage(termsChecked: boolean): void
  abstract placeOrderWithPayment(returnMac: string, hostedCheckoutId: string): void
  abstract resetIngenicoPayment(): void
}
